import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import PriceSimulator from './components/PriceSimulator';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/price-simulator" element={<PriceSimulator />} />
            </Routes>
        </Router>
    );
}

export default App;
